import React, { useContext, useEffect, useState } from 'react';
import closeBtn from '../../../images/close-btn.png';
import commentBtn from '../../../images/comment_icon.png';
import classes from './PatientStat.module.css';
import plusBtn from '../../../images/plus-btn.png';
import minusBtn from '../../../images/minus-btn.png';
import MyButton from '../MyButton/MyButton';
import MyModal from '../MyModal/MyModal';
import WriteComment from '../WriteComment/WriteComment';
import Chart from '../Сhart/Chart';
import {
    createTherapyComment,
    getOneTherapy,
    getTherapyComments,
    updateTherapySpO2,
} from '../../../API/therapyApi';
import { MainContext } from '../../..';
import { observer } from 'mobx-react-lite';
import { useFillIndicatorsArrays } from '../../../hooks/useFillIndicatorsArrays';
import { useWebSocketUpdations } from '../../../hooks/useWebSocketUpdations';
import { usePatient } from '../../../hooks/usePatient';

const PatientStat = observer(({ patientId, therapyId, bedId, setViewPatientStatsVisible }) => {
    const CHARTS_TIME_LENGTH = 60; // 60 секунд

    const { medicalStore } = useContext(MainContext);

    const [writeCommentVisible, setWriteCommentVisible] = useState(false);
    const [comments, setComments] = useState([]);
    const [newSpO2, setNewSpO2] = useState(99);
    const [isSpO2InChanging, setIsSpO2InChanging] = useState(false);
    const [patient, setPatient] = useState();
    const [indicatorUpdate, setIndicatorUpdate] = useState({
        id: 0,
        patient: patientId, // ID пациента, для которого это обновление
        pulse: 0,
        respiratory_rate: 0,
        saturation: 0,
        oxygen_flow: 0,
        timestamp: Date.now(),
    });
    const [spo2Update, setSpo2Update] = useState({
        therapy_id: therapyId,
        patient_id: patientId,
        spO2_value: 0,
    });
    const [pulse, setPulse] = useState([
        {
            value: 0,
            timestamp: Date.now(),
        },
    ]);
    const [respiratory_rate, setRespiratory_rate] = useState([
        {
            value: 0,
            timestamp: Date.now(),
        },
    ]);
    const [saturation, setSaturation] = useState([
        {
            value: 0,
            timestamp: Date.now(),
        },
    ]);
    const [oxygen_flow, setOxygen_flow] = useState([
        {
            value: 0,
            timestamp: Date.now(),
        },
    ]);

    // Установка пациента
    usePatient(patientId, setPatient);

    // Загрузка комментариев
    useEffect(() => {
        const fetchComments = async () => {
            const commentsArr = await getTherapyComments(therapyId);
            setComments(commentsArr);
        };
        fetchComments();
    }, [writeCommentVisible, spo2Update]);

    useEffect(() => {
        setNewSpO2(spo2Update?.spO2_value);
    }, [spo2Update]);

    useEffect(() => {
        const therapy = medicalStore.therapies.find((t) => t.id === therapyId);
        setSpo2Update({
            therapy_id: therapy.id,
            patient_id: therapy.patient,
            spO2_value: therapy.spO2_value,
        });
    }, []);

    // Установка нового целевого значения SpO2
    const updateSpO2 = async () => {
        try {
            const updateTherapySpO2Data = await updateTherapySpO2(therapyId, newSpO2);
            const commentData = await createTherapyComment(
                therapyId,
                `Целевое SpO2: ${spo2Update?.spO2_value}% → ${newSpO2}%`
            );
            setIsSpO2InChanging(false);
        } catch (e) {
            console.log(e);
            alert(e.response.data.message);
        }
    };

    useWebSocketUpdations(patientId, setIndicatorUpdate, setSpo2Update);

    useFillIndicatorsArrays(
        indicatorUpdate,
        pulse,
        setPulse,
        respiratory_rate,
        setRespiratory_rate,
        saturation,
        setSaturation,
        oxygen_flow,
        setOxygen_flow
    );
    return (
        <>
            <div className={classes.patientStat}>
                <div className={classes.header}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {/* <div className={classes.avaContainer}>
                            <img src={patientAva} alt="Фото пациента" />
                        </div> */}
                        <div className={classes.patientData}>
                            <div className={classes.bedId}>
                                <div className={classes.place_value}>{bedId}</div>
                                <div className={classes.indicator_place}>место</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div className={classes.patientName}>ID пациента: {patientId}</div>
                                <div className={classes.patientName}>ID терапии: {therapyId}</div>
                                <div className={classes.patientName}>
                                    Имя: {patient?.user?.full_name}
                                </div>
                                <div className={classes.patientAge}>
                                    Год рождения: {patient?.birthdate}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={() => setViewPatientStatsVisible(false)}
                        className={classes.nullBtn}
                        style={{ display: 'flex', justifyContent: 'start' }}
                        title="Закрыть"
                    >
                        <img src={closeBtn} style={{ width: 50, height: 50 }} />
                    </button>
                </div>
                <div className={classes.body}>
                    <div className={classes.charts}>
                        <div className={classes.indicatorAndChart}>
                            <div className={classes.indicator}>
                                <div className={classes.indicator_value}>
                                    {indicatorUpdate?.pulse}
                                </div>
                                <div className={classes.indicator_name}>Пульс</div>
                            </div>
                            <div className={classes.chart}>
                                <Chart
                                    data={pulse}
                                    // minX={1 - CHARTS_TIME_LENGTH}
                                    // maxX={0}
                                    minY={
                                        Math.min(...(pulse?.map((p) => p?.value ?? 0) ?? [0])) ?? 0
                                    }
                                    maxY={
                                        Math.max(...(pulse?.map((p) => p?.value ?? 0) ?? [100])) ??
                                        150
                                    }
                                />
                            </div>
                        </div>
                        <div className={classes.indicatorAndChart}>
                            <div className={classes.indicator}>
                                <div className={classes.indicator_value}>
                                    {indicatorUpdate?.respiratory_rate}
                                </div>
                                <div className={classes.indicator_name}>чдд</div>
                            </div>
                            <div className={classes.chart}>
                                <Chart
                                    data={respiratory_rate}
                                    // minX={1 - CHARTS_TIME_LENGTH}
                                    // maxX={0}
                                    minY={
                                        Math.min(
                                            ...(respiratory_rate?.map((p) => p?.value) ?? [0])
                                        ) ?? 0
                                    }
                                    maxY={
                                        Math.max(
                                            ...(respiratory_rate?.map((p) => p?.value) ?? [0])
                                        ) ?? 50
                                    }
                                />
                                {/* <Chart /> */}
                            </div>
                        </div>
                        <div className={classes.indicatorAndChart}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '15%',
                                    marginRight: 10,
                                }}
                            >
                                <div
                                    className={classes.indicator}
                                    style={
                                        isSpO2InChanging
                                            ? {
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  width: '60%',
                                                  gap: 5,
                                              }
                                            : { width: '100%', margin: 0 }
                                    }
                                    title={
                                        isSpO2InChanging
                                            ? ''
                                            : 'Нажмите, чтобы открыть редатирования SpO2'
                                    }
                                    onClick={() => setIsSpO2InChanging(true)}
                                >
                                    <div className={classes.indicator_value}>
                                        {indicatorUpdate?.saturation}%
                                    </div>
                                    <div style={{ fontSize: 14 }}>
                                        Цель: {spo2Update?.spO2_value}%
                                    </div>
                                    {isSpO2InChanging ? (
                                        <div style={{ fontSize: 14 }}>
                                            <div style={{ fontSize: 14 }}>Новая цель:</div>
                                            <input
                                                style={{
                                                    width: '90%',
                                                    marginInline: '5%',
                                                    boxSizing: 'border-box',
                                                }}
                                                value={newSpO2}
                                                type="number"
                                                min="0"
                                                max="100"
                                                onChange={(e) => {
                                                    if (
                                                        e.target.value <= 99 &&
                                                        e.target.value >= 1
                                                    ) {
                                                        setNewSpO2(Number(e.target.value));
                                                    } else if (!(e.target.value <= 99)) {
                                                        setNewSpO2(100);
                                                    } else if (!(e.target.value >= 1)) {
                                                        setNewSpO2(0);
                                                    }
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        ''
                                    )}

                                    <div className={classes.indicator_name}>SpO2</div>
                                </div>

                                {isSpO2InChanging ? (
                                    <div className={classes.flowButtons}>
                                        <MyButton
                                            title="Закрыть"
                                            onClick={() => setIsSpO2InChanging(false)}
                                        >
                                            ✘
                                        </MyButton>
                                        <MyButton
                                            title="Сохранить значение целевой сатурации"
                                            onClick={updateSpO2}
                                        >
                                            ✔
                                        </MyButton>
                                        <MyButton
                                            title="Увеличить целевую сатурацию на 1%"
                                            onClick={() => {
                                                if (newSpO2 <= 99) {
                                                    setNewSpO2(newSpO2 + 1);
                                                } else {
                                                    setNewSpO2(100);
                                                }
                                            }}
                                        >
                                            +
                                        </MyButton>
                                        <MyButton
                                            title="Уменьшить целевую сатурацию на 1%"
                                            onClick={() => {
                                                if (newSpO2 >= 1) {
                                                    setNewSpO2(newSpO2 - 1);
                                                } else {
                                                    setNewSpO2(0);
                                                }
                                            }}
                                        >
                                            –
                                        </MyButton>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                            <div className={classes.chart}>
                                <Chart
                                    data={saturation}
                                    // minX={1 - CHARTS_TIME_LENGTH}
                                    // maxX={0}
                                    minY={
                                        Math.min(...(saturation?.map((p) => p?.value) ?? [0])) ?? 0
                                    }
                                    maxY={
                                        Math.max(...(saturation?.map((p) => p?.value) ?? [0])) ??
                                        100
                                    }
                                />
                                {/* <Chart /> */}
                            </div>
                        </div>
                        <div className={classes.indicatorAndChart}>
                            <div className={classes.indicator}>
                                <div className={classes.indicator_value}>
                                    {indicatorUpdate?.oxygen_flow}
                                </div>
                                <div className={classes.indicator_name}>л/мин</div>
                            </div>
                            <div className={classes.chart}>
                                <Chart
                                    data={oxygen_flow}
                                    // minX={1 - CHARTS_TIME_LENGTH}
                                    // maxX={0}
                                    minY={
                                        Math.min(...(oxygen_flow?.map((p) => p?.value) ?? [0])) ?? 0
                                    }
                                    maxY={
                                        Math.max(...(oxygen_flow?.map((p) => p?.value) ?? [0])) ??
                                        10
                                    }
                                />
                                {/* <Chart /> */}
                            </div>
                        </div>
                    </div>
                    <div className={classes.comments}>
                        <div className={classes.commentsHeader}>
                            <div
                                style={{
                                    display: 'flex',
                                    fontSize: 28,
                                    // fontSize: "xx-large",
                                    // fontSize: "150%",
                                    // fontSize: 'calc(16px + 16 * (100vh / 1200))',
                                    fontWeight: 'bold',
                                    marginInline: 'auto',
                                }}
                            >
                                Комментарии
                            </div>
                            <button
                                className={classes.nullBtn}
                                title="Добавить комментарий"
                                onClick={() => setWriteCommentVisible(true)}
                            >
                                <img src={commentBtn} />
                            </button>
                        </div>
                        <div className={classes.commentsList}>
                            {/* С сортировкой по убыванию */}
                            {comments
                                // .slice()
                                .sort((a, b) => b.created_at - a.created_at)
                                .map((comment) => (
                                    <div key={comment.id} className={classes.commentItem}>
                                        <div className={classes.commentItemValue}>
                                            {comment.text}
                                        </div>
                                        <div className={classes.commentItemAuthor}>
                                            {comment.author.full_name}
                                        </div>
                                        <div className={classes.commentItemDate}>
                                            {comment.created_at.slice(0,10)} {comment.created_at.slice(11,16)}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
            <MyModal visible={writeCommentVisible} setVisible={setWriteCommentVisible}>
                <WriteComment
                    therapyId={therapyId}
                    setWriteCommentVisible={setWriteCommentVisible}
                />
            </MyModal>
        </>
    );
});

export default PatientStat;

